export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${month}/${day}/${year} ${hours}:${minutes}`;
};

export const isOverdue = (dueDate, status) => {
  if (!dueDate || status === 'Completada') return false;
  const due = new Date(dueDate);
  const now = new Date();
  return due < now;
};

export const getDaysUntilDue = (dueDate) => {
  if (!dueDate) return null;
  const due = new Date(dueDate);
  const now = new Date();
  const diffTime = due - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const isToday = (dateString) => {
  if (!dateString) return false;
  const date = new Date(dateString);
  const today = new Date();
  return date.toDateString() === today.toDateString();
};

export const isThisWeek = (dateString) => {
  if (!dateString) return false;
  const date = new Date(dateString);
  const today = new Date();
  const weekFromNow = new Date();
  weekFromNow.setDate(today.getDate() + 7);
  return date >= today && date <= weekFromNow;
};

// Semana = Sábado 00:00 → Viernes 23:59 (America/New_York)
export const getCurrentWeekRange = () => {
  const now = new Date();
  const dayOfWeek = now.getDay(); // 0 = Sunday, 6 = Saturday
  
  // Calculate days to last Saturday
  let daysToSaturday;
  if (dayOfWeek === 6) { // Saturday
    daysToSaturday = 0;
  } else if (dayOfWeek === 0) { // Sunday
    daysToSaturday = 1;
  } else { // Monday-Friday (1-5)
    daysToSaturday = dayOfWeek + 1;
  }
  
  const weekStart = new Date(now);
  weekStart.setDate(now.getDate() - daysToSaturday);
  weekStart.setHours(0, 0, 0, 0);
  
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6); // Friday
  weekEnd.setHours(23, 59, 59, 999);
  
  return { weekStart, weekEnd };
};

export const getWeekLabel = (weekStart) => {
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);
  const fmt = (d) => {
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${m}.${day}`;
  };
  return `Sáb ${fmt(weekStart)} — Vie ${fmt(weekEnd)}`;
};

export const getPastWeeks = (count = 12) => {
  const weeks = [];
  const { weekStart } = getCurrentWeekRange();
  
  for (let i = 0; i < count; i++) {
    const start = new Date(weekStart);
    start.setDate(weekStart.getDate() - (i * 7));
    weeks.push(start);
  }
  
  return weeks;
};